<template>
    <div class="main-container">
      <div class="headerClass">
        <tl-header type="h1">
          <div class="main-header">National pension scheme(NPS) declaration</div>
        </tl-header>
      </div>
      <div class="permission-alert-msg" v-show="showErrorMessage">
              NPS Declare amount must be lesser than NPS eligibility
              value RS{{tenPercentOF_basic_DA}}.
            </div>
      <div class="permission-alert-msg" v-show="showPercentageError">
              NPS Declare amount must be lesser than or equal to 10%
            </div>
            <pop-up-message
            v-if="showSuccessMsg"
            :message="successMessage"
            btnText="Back"
            @back="backFromPopUp()"
          />
          <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
          <div class="heading">
            <p><b>Employee's Contribution Type</b><small class="color"> *</small></p>
          </div>
      <div class="uploadMethoRadio">
              <tl-radio
                name="uploadType"
                label="Percentage"
                id="Percentage"
                value="percentage"
                v-model="radioType"
              />
              <tl-radio
                name="uploadType"
                label="Fixed"
                id="Fixed"
                value="fixed"
                v-model="radioType"
              />
            </div>
      <div class="contributionHeading">
        <div>
          <div class="heading">
            <p><b>Employee's Contribution</b><small class="color"> *</small></p>
          </div>
  
          <div class="buttonGroup">
            <span v-if="radioType == 'percentage'" class="content">{{ validationText }}</span>
            <txt
              v-if="radioType == 'fixed'"
              autofocus="autofocus"
              v-numeric-only
              type="text"
              data-vv-as="name"
              name="nps_name"
              v-model="npsEnterdValue"
              @change="valueValidationFunction()"
              :classname="errors.has('nps_name')"
              :errormsg="errors.first('nps_name')"
            />
            <div>
              <txt
              v-if="radioType == 'percentage'"
              autofocus="autofocus"
              v-numeric-only
              type="text"
              data-vv-as="name"
              name="nps_name"
              v-maxchars="2"
              v-model="npsEnterdValue"
              @change="valueValidationFunction()"
              :classname="errors.has('nps_name')"
              :errormsg="errors.first('nps_name')"
            />
            </div>
            <span class="inputContent">Per Month</span>
          </div>
        </div>
      </div>
      <bottom-action-container class="placeAtEnd">
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="previousPage()" />
            <btn :disabled="showErrorMessage || showPercentageError" text="Save" type="primary" @click="updateNpsDetails()" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </template>

  <script>
import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        uploadMethod:"true",
        validationText:"% of Basic + DA",
        radioType:"percentage",
        npsEnterdValue:"",
        showErrorMessage :false,
        showSuccessMsg :false,
        successMessage :"",
        showPercentageError:false,
        payloadData:{},
        toast:false,
        errmsg:"",
        empBasicSalary:0,
        empDA:0,
        tenPercentOF_basic_DA :0,
      };
    },
    watch:{
          radioType(){
              if(this.radioType == "fixed")
              {
                this.validationText = ""
              }
              else{
                this.validationText = "% of Basic +DA"
              }
          }
    },
    mounted(){
      this.fectchNpsData()
    },
    updated(){
    },
    computed:{
      empId(){
      return localStorage.getItem("empId")
    },
    },
    methods:{
    ...mapActions({
      act_fetch_nps_details:"dashboard/nps/fetchallFunction",
      act_update_nps_details:"dashboard/nps/updateNpsData"
    }),
    backFromPopUp() {
       this.showSuccessMsg = false;
       this.refresh();
       },
    async valueValidationFunction(){
         if(this.radioType == "percentage" && this.npsEnterdValue >10 ){
          this.showPercentageError =true
         }
         else{
          this.showPercentageError =false
         }
         if(this.npsEnterdValue <= this.tenPercentOF_basic_DA && this.radioType == "fixed"){
            this.showErrorMessage =false
         }
         else if(this.radioType == "percentage"){
          this.showErrorMessage =false
         }
         else{
          this.showErrorMessage = true
         }
      },
    async fectchNpsData(){
       try{
        const payloadData={
          employee_id:this.empId
      }
        let res=await this.act_fetch_nps_details(payloadData)
        if(!res.data.payload["NPS Data"][0]){
          this.radioType = "percentage"
          this.empBasicSalary = res.data.payload.SalaryComponents[0].value
           this.empDA = res.data.payload.SalaryComponents[1].value
           this.basic_DA = ((this.empBasicSalary + this.empDA)/100)
           let value_validated_with_percentage = ((this.empBasicSalary + this.empDA)/100)*10
           this.tenPercentOF_basic_DA = value_validated_with_percentage
        }
        else{
        this.radioType =res.data.payload["NPS Data"][0].type
        if(res.data.payload["NPS Data"][0].type == 'percentage'){
          this.npsEnterdValue = res.data.payload["NPS Data"][0].percentage
        }
        else{
          this.npsEnterdValue = res.data.payload["NPS Data"][0].value
        }
        this.empBasicSalary = res.data.payload.SalaryComponents[0].value
           this.empDA = res.data.payload.SalaryComponents[1].value
           this.basic_DA = ((this.empBasicSalary + this.empDA)/100)
           let value_validated_with_percentage = ((this.empBasicSalary + this.empDA)/100)*10
           this.tenPercentOF_basic_DA = value_validated_with_percentage
      }
       }catch(err){
        this.toast = true
        this.errmsg = err
       }
    },
    async updateNpsDetails(){
     try{
      const date = new Date()
      let fullDate=(date.getMonth()+1) +"-"+ date.getDate() +"-"+ date.getFullYear()
       if(this.radioType == "percentage"){
          this.payloadData={
           employee_id:this.empId,
           type:this.radioType,
           value:this.npsEnterdValue,
           declaration_date:fullDate
          }
         }else{
           this.payloadData={
           employee_id:this.empId,
           type:this.radioType,
           value:this.npsEnterdValue,
           declaration_date:fullDate
       }
      }
       let res = await this.act_update_nps_details(this.payloadData)
       if(res.status){
             this.showSuccessMsg = true
             this.successMessage = res.data.message
           }
     }catch(err){
      this.toast = true
       this.errmsg = err
     }
    }

    },
  };
  </script>
  <style lang="scss" scoped>
  @import "@/scss/components/margins.scss"; //margins

  /* .mainHeading {
    font-weight:550;
    color:rgba(18, 18, 20,0.690);
    font-style:inherit
  } */
  .contributionHeading{
      display: flex;
      flex-direction: column;
      gap: 35px;
  }
  .heading {
    margin:15px 15px;
  }
  .heading2{
   margin-bottom: -10px;   
  }
  .dropdownDiv{
      width: 30%;
  }
  .buttonGroup {
    display: flex;
    margin-left:25px
  }
  .content {
    border-style: solid;
    border-radius: 5px;
    border-width: 2px;
    border-color: rgb(179, 245, 240);
    padding-left: 15px;
    padding-top: 5px;
    padding-right: 20px;
    // background-color: rgba(245, 244, 253);
  }
  .contributionEnds {
    margin-top: -5px;
    display: flex;
    align-items: center;
  }
  .dropdowncontent {
    padding-top: 10px;
  }
  .inputContent {
    padding-top: 8px;
  }
  .alligning {
    padding-left: 10px;
  }
  .color {
    color: red;
  }
  .uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
  margin-left: 25px
}
  </style>
  